'use client';

import type { Column } from '@tanstack/react-table';
import { cn } from '@zealot/ui/lib/utils';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

type DataTableColumnHeaderProps<TData, TValue> = {
  column: Column<TData, TValue>;
  title: string;
  className?: string;
};

const DataTableColumnHeader = <TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) => {
  if (!column.getCanSort()) {
    return (
      <div data-slot="data-table-column-header" className={cn(className)}>
        {title}
      </div>
    );
  }

  const sorted = column.getIsSorted();

  return (
    <button
      data-slot="data-table-column-header"
      type="button"
      className={cn(
        '-ml-2 inline-flex h-7 items-center gap-1 rounded-md px-2 font-medium text-xs transition-colors hover:bg-accent/50',
        className,
      )}
      onClick={() => column.toggleSorting(sorted ? sorted === 'asc' : column.columnDef.sortDescFirst === true)}
    >
      {title}
      {sorted === 'asc' ? (
        <ArrowUp className="size-3.5 text-foreground" />
      ) : sorted === 'desc' ? (
        <ArrowDown className="size-3.5 text-foreground" />
      ) : (
        <ArrowUpDown className="size-3.5 text-muted-foreground" />
      )}
    </button>
  );
};

export type { DataTableColumnHeaderProps };
export { DataTableColumnHeader };
